import React from 'react';

function withNewLine(text) {
  if (!text) return null;

  return text.split('\n').map((item, i) => (
    <React.Fragment key={i}>
      {item}<br />
    </React.Fragment>
  ));
}

const ProductInfoTable = ({ details, fabric, sizing, sizeGuide, toggleSizeGuide }) => (
  <table className="product-details__table">
    <tbody>
      {details &&
        <tr className="product-details__row">
          <th className="product-details__header-cell">
            Details
          </th>
          <td className="product-details__info-cell">
            {withNewLine(details)}
          </td>
        </tr>}
      {fabric &&
        <tr className="product-details__row">
          <th className="product-details__header-cell">
            Fabric</th>
          <td className="product-details__info-cell">
            {withNewLine(fabric)}
          </td>
        </tr>}
      {sizing &&
        <tr className="product-details__row">
          <th className="product-details__header-cell">
            Sizing</th>
          <td className="product-details__info-cell">
            {withNewLine(sizing)}

            {sizeGuide &&
              <a href="#" onClick={toggleSizeGuide}>Size guide </a>}
          </td>
        </tr>}
    </tbody>
  </table>
);

export default ProductInfoTable;



// WEBPACK FOOTER //
// ./assets/scripts/components/Product/ProductInfoTable.js